import { createAction } from 'redux-actions';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { reduxKey } from './constants';
import { getRecipientForComment, getRecipientForDeviation } from '../utils';
export const pushAwardBadgeModal = (recipient)=>pushModal(ModalType.AWARD_BADGE, {
        params: {
            recipient
        },
        wrapInModal: false
    });
export const beginDeviationAwardBadgeFlow = (deviation)=>pushAwardBadgeModal(getRecipientForDeviation(deviation));
export const beginCommentAwardBadgeFlow = (comment)=>pushAwardBadgeModal(getRecipientForComment(comment));
export const awardBadge = createAction(`${reduxKey}/AWARD`, (badgeType, recipient)=>({
        badgeType,
        recipient
    }));
export const awardingBadge = createAction(`${reduxKey}/AWARDING`, ()=>({}));
export const awardBadgeSuccess = createAction(`${reduxKey}/AWARD.SUCCESS`, (badge, recipient, newBalance, allBadges)=>({
        badge,
        recipient,
        newBalance,
        allBadges
    }));
export const awardBadgeFail = createAction(`${reduxKey}/AWARD.FAIL`, (badgeType, recipient, errorMsg)=>({
        badgeType,
        recipient,
        errorMsg
    }));
export const fetchAvailableBadges = createAction(`${reduxKey}/FETCH_AVAILABLE_BADGES`, (userId)=>({
        userId
    }));
export const fetchAvailableBadgesSuccess = createAction(`${reduxKey}/FETCH_AVAILABLE_BADGES.SUCCESS`, (userId, results)=>({
        userId,
        results
    }));
export const fetchBadgeGiverStreamNext = createAction(`${reduxKey}/BADGE_GIVER_STREAM.FETCH_NEXT`, (streamId)=>({
        streamId
    }));
